import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AnyMxRecord } from "dns";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { ClientEmployeeContactBO } from "../../client-employee-contact/client-employee-contact.model";
import { employeeOnboardEmit } from "../../employee-agreementlist/employee-agreementlist.model";

import { CommonHttpService } from "src/app/common.service"
import {
  ContactInfoLst,
  EmployeeBO,
  functionpermission,
  IsViewEdit,
  IsViewEditpayorequired,
  IsViewEditpayrate,
  SendToPortalBO,
} from "../employee.model";
import { EmployeeService } from "../employee.service";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { ClientEmployeeRelationshipBO } from "../../client-employee-relationship/client-employee-relationship.modal";

import { ClientHttpService } from "../../client-parent/client-parent.service";
import { ClientEmployeeDynamicFormBO } from "../../client-employee-dynamicform/client-employee-dynamicform.model";
import { ConfigurationService } from "src/app/configuration.service";

@Component({
  selector: "app-employee-create-edit",
  templateUrl: "./employee-create-edit.component.html",
  styleUrls: ["./employee-create-edit.component.scss"],
})
export class EmployeeCreateEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  saveEmployeeInProgress: boolean = false;
  Employee: EmployeeBO = new EmployeeBO();
  EmployeeDataForm: FormGroup;
  Dropdownlist: any;
  EmployeeTypeItems: any;
  isEnabledcontact: boolean = false;
  isEnable: boolean = true
  EmergencyContactList: any;
  ResponsiblePartyList: any;
  clientName: string;
  superVisorList: any;
  stateList: any;
  getLocationList: any = [];

  passerror: boolean = false;
  isRelationcontact: boolean = false;
  
  isEnabledNotes: boolean = false;
  isNotes : boolean = false;

  isEnabledPayroll= false;
  ispayrollinformation= false;

  isRelationShip: boolean = false;
  isEnabledRelationship: boolean = false;
  ClientEmployeeRelationship: ClientEmployeeRelationshipBO = new ClientEmployeeRelationshipBO();
  ClientEmployeeContact: ClientEmployeeContactBO = new ClientEmployeeContactBO();
  isEdit: boolean = false;
  isView: boolean = false;
  isShowFields: boolean = false;
  isEditDisable: boolean = false;
  DropdownId: any;
  enablerelation: boolean = false;
  relationenable: boolean = false;
  activeTab: string = "general";
  isNotesEdit: boolean = false;
  isPayRateEdit: boolean = null;
  editEmployeeId: string;
  isPayorRequiredEdit: boolean = false;
  EmployeestatusList: any = [];
  LanguageList: [{ Key: string, Value: string }];

  EmployeeTypeList: [{ Key: string; Value: string }];
  WithHoldingList: [{ Key: string; Value: string }];
  ContactTypeList: [{ Key: string; Value: string }];
  GenderList: [{ Key: string; Value: string }];
  LocationList: [{ Key: string; Value: string }];
  PayCHeckType: [{ Key: string; Value: string }];
  disabilityLst: [{ Key: string; Value: string }];
  raceLst: [{ Key: string; Value: string }];
  jobLst: [{ Key: string; Value: string }];
  Primaryjoblist: [{ Key: string; Value: string }];
  vetranDisabilityLst: [{ Key: string; Value: string }];
  phoneCarrierType: [{ Key: string; Value: string }];
  ContactRelationshipList: [{ Key: string; Value: string }];
  ChecklistType: [{ Key: string; Value: string }];
  @Input() ViewEdit: IsViewEdit = new IsViewEdit();
  @Output() isViewEdit = new EventEmitter<IsViewEdit>();
  disabledsavedbutton: boolean = false;
  fp: functionpermission = new functionpermission();
  EmployeeContactData: any;
  today = new Date();
  portalBo=new SendToPortalBO()
  employeevv:boolean = false;
  isdynamicFormEmployee: boolean = false;
  AddressGoogleMap: boolean = false;

  ClientEmployeeDynamicForm: ClientEmployeeDynamicFormBO = new ClientEmployeeDynamicFormBO();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  public myDatePickerOptionsLicense: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
   // disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  payrateview: IsViewEditpayrate = {
    isView: true,
    isEdit: false,
    isEditPayorrate: false,
    employeeId: this.Employee.id,
    payrateId: "00000000-0000-0000-0000-000000000000",
    payrate: [],
    payratetype: "",
    updatedata: "",
  };
  OnboardListemitBo: employeeOnboardEmit = new employeeOnboardEmit();

  payoRequiredViewEdit: IsViewEditpayorequired = {
    isView: true, isEdit: false, isEditPayorRequired: false, employeeId: "", payorRequiredId: "", payorRequired: [], payorActiotype: ''
  };

  constructor(private commonhttp: CommonHttpService,
    public toasterService: ToastrService,
    public formbuilder: FormBuilder,
    public general: GeneralService,
    public global: GlobalComponent,
    public dateservice: DateService,
    private employeeService: EmployeeService,
    public http: HttpClient,
    public datepipe: DatePipe,
    public configurationservice:ConfigurationService,
    public ClientService: ClientHttpService
  ) {
    this.global.checkforlogout();

    this.EmployeeDataForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      dateofBirth: new FormControl('', [Validators.required]),
      genderLid: new FormControl('', [Validators.required]),
      statusLid: new FormControl('', [Validators.required]),
      locationId: new FormControl('', [Validators.required]),
      middleName: new FormControl(''),
      employeeTypeLids: new FormControl('',),
      languageLid:new FormControl('', [Validators.required]),
      phone1: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      phone2: new FormControl("", [Validators.minLength(14), Validators.maxLength(14)]),
      zipcode: new FormControl(""),
      uMPI: new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]),
      rNNPI: new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]),
      pEmployeeId: new FormControl("",Validators.maxLength(9)),
      driverLicense: new FormControl ("", [Validators.minLength(10), Validators.maxLength(10)]),
      email: new FormControl('', [Validators.email, Validators.required]),
      pCACertificateNumber: new FormControl(""),
      username: new FormControl(""),
      password: new FormControl(""),
      sSN:new FormControl("", [Validators.minLength(9), Validators.maxLength(9)])
      // requiredEVV: [""],
    });
  }
  ngOnInit(): void {   
    this.getLanguage(); 
    this.getpermission();
    this.GetLanguageList();
    this.Employee.id = this.ViewEdit.editEmployee;
    this.tabchange(this.activeTab);
    this.getWithHoldingList();
    this.getLocationDropDown();
    this.getEmployeeStatus();
    this.getGenderList();
    this.getEmployeetype();
    this.ClientEmployeeContact.ContactType = 'Employee';
    this.ClientEmployeeContact.Id = this.ViewEdit.editEmployee;

    this.ClientEmployeeRelationship.RelationshipType = 'Employee';
    this.ClientEmployeeRelationship.Id = this.ViewEdit.editEmployee;
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
   
    this.ClientEmployeeDynamicForm.Dynamictype = "Employee";
    if (this.Employee.id != "00000000-0000-0000-0000-000000000000") {
      this.ClientEmployeeDynamicForm.Id = this.Employee.id;
      this.isEditDisable = true;
      this.global.viewTabs = true;
      this.activeTab = "general";
      this.EmployeeDataForm.disable();
      this.getEmployeeEditedList();
      if (!this.Employee.requiredEVV) {
        this.EmployeeDataForm.controls['password'].disable();
        this.EmployeeDataForm.controls['username'].disable();
      }
      if(this.Employee.username != null && this.Employee.username != undefined && this.Employee.username != ""){
        this.Employee.requiredEVV = true;
      }
      else{
        this.Employee.requiredEVV = false;
      }
    }
    else {
      this.Employee = new EmployeeBO();
      this.EmployeeDataForm.reset();
      this.Employee.id = "00000000-0000-0000-0000-000000000000";
      this.EmployeeDataForm.controls['password'].disable();
      this.EmployeeDataForm.controls['username'].disable();
    }
    this.getPortalCheck();
  }
  
  // ...................................getEmployeeEditedList.......................................
  getEmployeeEditedList() {
    this.Employee = JSON.parse(JSON.stringify(this.ViewEdit.Employeedata));
    setTimeout(() => {
      this.Employee.dOB = this.datepipe.transform(this.ViewEdit.Employeedata.dob, "MM/dd/yyyy");
      if(this.Employee.driverLicenseExpirydate != null) {
      this.Employee.driverLicenseExpirydate = this.datepipe.transform(this.ViewEdit.Employeedata.driverLicenseExpirydate, "MM/dd/yyyy")
        }
    }, 300);
    this.Employee.uMPI = this.ViewEdit.Employeedata.umpi;
    this.Employee.rNNPI = this.ViewEdit.Employeedata.rnnpi;
    this.Employee.aKA = this.ViewEdit.Employeedata.aka;
    this.Employee.sSN = this.ViewEdit.Employeedata.ssn;
    this.Employee.pCACertificateNumber = this.ViewEdit.Employeedata.pcaCertificateNumber;
  }
  //...................................................SaveorUpdateEmployee................................................
  SaveorUpdateEmployee(Employee) {
    this.saveEmployeeInProgress = true;
    let employeesave = JSON.parse(JSON.stringify(Employee));
    //  DOB
    employeesave.agencyId=this.global.globalAgencyId;
    employeesave.dob = (this.Employee.dOB != null && this.Employee.dOB != undefined && this.Employee.dOB != '' && this.Employee.dOB != null) ?
      this.global.getDateTimeString(this.Employee.dOB) : null;
    employeesave.dOB = (this.Employee.dOB != null && this.Employee.dOB != undefined && this.Employee.dOB != '' && this.Employee.dOB != null) ?
      this.global.getDateTimeString(this.Employee.dOB) : null;
console.log(  employeesave.dob)
    // terminationdate
    employeesave.terminationdate = (this.Employee.terminationdate != null && this.Employee.terminationdate != undefined && this.Employee.terminationdate != '' && this.Employee.terminationdate != null) ?
      this.global.getDateTimeString(this.Employee.terminationdate) : null;
    // hiredate
    employeesave.hiredate = (this.Employee.hiredate != null && this.Employee.hiredate != undefined && this.Employee.hiredate != '' && this.Employee.hiredate != null) ?
      this.global.getDateTimeString(this.Employee.hiredate) : null;
    // inactivedate
    employeesave.inactivedate = (this.Employee.inactivedate != null && this.Employee.inactivedate != undefined && this.Employee.inactivedate != '' && this.Employee.inactivedate != null) ?
      this.global.getDateTimeString(this.Employee.inactivedate) : null;

    employeesave.phone1=employeesave.phone1 != null && employeesave.phone1 != undefined ? this.general.reconverPhoneGoogleLib(employeesave.phone1):null
    employeesave.phone2=employeesave.phone2 != null && employeesave.phone2 != undefined ? this.general.reconverPhoneGoogleLib(employeesave.phone2):null

    employeesave.maritalStatusLid = employeesave.maritalStatusLid != null ? employeesave.maritalStatusLid : null;
    employeesave.driverLicenseExpirydate = (this.Employee.driverLicenseExpirydate != null && this.Employee.driverLicenseExpirydate != undefined && this.Employee.driverLicenseExpirydate != '' ) ?
    this.global.getDateTimeString(this.Employee.driverLicenseExpirydate) : null;
    this.employeeService.saveEmployeedata(employeesave).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.ClientEmployeeContact.Id =  JSON.parse(data);
      this.ClientEmployeeRelationship.Id =  JSON.parse(data);
      this.saveEmployeeInProgress = false;
      if (this.Employee.id == "00000000-0000-0000-0000-000000000000") {
        this.toasterService.success('Employee saved SuccessFully');
        this.isEditDisable = true;
        this.EmployeeDataForm.disable();
        this.global.viewTabs = true;
        this.Employee.id = JSON.parse(data);
      }
      else {
        this.toasterService.success('Employee updated SuccessFully');
      }
    },
    (err: any) => {
      this.toasterService.error(err);
      this.saveEmployeeInProgress = false;
      this.isEditDisable = false;
      this.global.viewTabs = false;
      this.EmployeeDataForm.enable();


      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
    }
    )
  }
  //..................................................backToEmployeeList......................................................................
  backToEmployeeList() {
    this.isEdit = false;
    if (this.isView) {
      this.isView = false;
    }
    this.isViewEdit.emit({
      isView: false,
      isEdit: false,
      isEditEmployee: false,
      editEmployee: "00000000-0000-0000-0000-000000000000",
      Employeedata: new EmployeeBO(),
      isEmployeefilterEnable: this.ViewEdit.isEmployeefilterEnable,
      EmployeefilterDetails: this.ViewEdit.EmployeefilterDetails,
      isaEmployeeNew: false,
    });
  }
  //.................................................editFunctionButton...............................................................
  editFunctionButton() {
    this.isShowFields = true;
    this.isEditDisable = false;
    this.global.viewTabs = false;
    this.EmployeeDataForm.enable();
    this.getPortalCheck()
  }
  EmployeeChange() {
    console.log("Before",this.Employee.driverLicenseExpirydate);
    if(this.Employee.driverLicense == null || this.Employee.driverLicense==undefined || this.Employee.driverLicense==''){
      this.Employee.driverLicenseExpirydate=null;
    }    
    console.log("After",this.Employee.driverLicenseExpirydate);
  }
  ssnerr=false
  EmployeeChangeSSN(){
    if(this.Employee.sSN !=null &&this.Employee.sSN!=undefined && this.Employee.sSN!='' ){
      
      if(this.Employee.sSN.length!=0 && this.Employee.sSN.length!=9 ){
            this.ssnerr=true
      }
      else{
        this.ssnerr=false
      }
    }
    else{
      this.ssnerr=false
    }
  }
  //...............................................closeSsnValidation...................................................
  closeSsnValidation() {
 
      document.getElementById("closessnModal").click();
    
  }


  //.................................................tabchange...........................................................
 employeewages:boolean=false
  tabchange(val) {
    this.activeTab = val;
    if (val == "payor") {
      this.isPayorRequiredEdit = false;
    } else {
      this.isPayorRequiredEdit = null;
    }

    if (val != "notes") {
      this.isEnabledNotes= false;
      this.isNotes= false;

    }
    if (val == "notes") {
      this.isNotes = true;
      
    }


    if (val != "payrollinformation") {
      this.isEnabledPayroll= false;
      this.ispayrollinformation= false;

    }
    if (val == "payrollinformation") {
      this.ispayrollinformation = true;
      
    }



    if (val == "payrate") {
      this.isPayRateEdit = false;
      //  this.Employee.id='1234567889'
    } else {
      this.isPayRateEdit = null;
    }
    if (val != 'contact') {
      this.isEnabledcontact = false;
      this.isRelationcontact = false;

    }
    if (val == 'contact') {
      this.isRelationcontact = true;

    }

    
    if (val != "Relationship") {
      this.isEnabledRelationship = false;
      this.isRelationShip = false;
    }
    if (val == "Relationship") {
      this.isRelationShip = true;
     
    }

    if (val == "document") {
    }
    if(val != "document"){
      this.OnboardListemitBo.employeeToDocument=false
    }
    if (val == "dynamicEmployeeInfo") {
      this.isdynamicFormEmployee = true;
    }
    if (val != "dynamicEmployeeInfo") {
      this.isdynamicFormEmployee = false;
    }
    if(val == "EmployeewagesInfo") {
      this.employeewages=true
    }
    if(val != "EmployeewagesInfo") {
      this.employeewages=false
    }
  }
  
 
  //.............................................. DOBdatechange..............................................
  DOBdatechange(event: IMyInputFieldChanged,type) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != '/') {
      if(type== 'dob') {
      this.Employee.dOB = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);

      } else if(type=='license') {
      this.Employee.driverLicenseExpirydate = value.substring(0, 2) + '/' + value.substring(2, 4) + '/' + value.substring(4, 10);

      }
    }

  }
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'LicenseExpiryDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.Employee.driverLicenseExpirydate = element;
          console.log("inpufield",this.Employee.driverLicenseExpirydate)

        }
      }
   
    }
    if (type == "datechanged") {
      if (name == 'LicenseExpiryDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.Employee.driverLicenseExpirydate = element;
          console.log("Datecha",this.Employee.driverLicenseExpirydate)
        }
      }
    

    }
  }
  //............................................. onDateChanged............................................ 
  onDateChanged(event: IMyDateModel) {
    this.Employee.dOB = event.formatted;
    var bdate = new Date(event.formatted);
    var today = new Date();
    var bdate = new Date(event.formatted);
    var age = 0;
    if (bdate.getFullYear() >= today.getFullYear()) {
      age = 0
    }
    else {
      var age = today.getFullYear() - bdate.getFullYear();
      var m = today.getMonth() - bdate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < bdate.getDate())) {
        age--;
      }
    }
    this.Employee.age = age;
    if (this.Employee.dOB == null || this.Employee.dOB == undefined || this.Employee.dOB == '') {
      this.Employee.age = null;
    }
  }
//......................................keyPress....................................
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //......................................isalphanumbericonly....................................
  isalphanumbericonly(event) {
    if (!(this.global.isdigit(event.key) || this.global.isalpha(event.key))) {
      event.preventDefault();
    }
  }
   //......................................numbersOnly....................................
  numbersOnly(event) {
    if (!this.global.isdigit(event.key)) {
      event.preventDefault();
    }
  }
  //......................................DemographicPhoneFormat....................................
  DemographicPhoneFormat() {
    this.Employee.phone1 = this.general.converPhoneGoogleLib(this.Employee.phone1)
    this.Employee.phone2 = this.general.converPhoneGoogleLib(this.Employee.phone2)
  }
 
  getZip() { }

  ///////////////////////////////////////Event Emit pay rate//////////////////////////////////////
  dataEmitfromPayrate(event: IsViewEditpayrate) {
    setTimeout(() => {
      this.isPayRateEdit = event.isEdit;
      this.payrateview = event;
    }, 1000);
  }
  goToAgreement() {
    this.OnboardListemitBo.employeeToDocument = true;
    this.OnboardListemitBo.isNew = true;
    this.OnboardListemitBo.employeeId=this.Employee.id
  }
  dataEmitFromOnboard(value) {
    this.OnboardListemitBo.employeeToDocument = false;
  }
  //....................................switchchange......................................................................
  switchchange() {
    if (this.Employee.requiredEVV) {
      this.EmployeeDataForm.controls['password'].enable();
      this.EmployeeDataForm.controls['username'].enable();
      document.getElementById('sendToEmploye').click();
    }
    else {
      this.EmployeeDataForm.controls['password'].disable();
      this.EmployeeDataForm.controls['username'].disable();
      document.getElementById('openEvvModal').click();
    }
  }
  //........................................switchchangeETimesheet.......................................................
  switchchangeETimesheet(val) {
    this.Employee.isEligibleForManualETimeSheet = val.checked

  }
  //.....................................getEmployeetype.......................................................
  getEmployeetype() {
    let params = new URLSearchParams();
    params.append("ListCode", "EMPLOYEETYPE");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeTypeItems = data;
    })

  }
   //.............................................getLanguage..........................................................
   
   getLanguage() {
    let params = new URLSearchParams();
    params.append("listCode", "Language");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.LanguageList = data;
    })
  }
disablePortalBtn=false
  getPortalCheck() {
    let params = new URLSearchParams();
    params.append("EmployeeId",this.Employee.id);
    this.employeeService.getportalCreateCheck(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if(data){
        this.disablePortalBtn=false
      }else{
       this.disablePortalBtn=true
      }
    })
  }
  //.....................................getGenderList.......................................................
  getGenderList() {
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.GenderList = data;
    })
  }
  
  //.....................................getEmployeeStatus.......................................................
  getEmployeeStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeestatusList = data;
      if(this.Employee.id=='00000000-0000-0000-0000-000000000000'){
        console.log('activee');
        
      this.Employee.statusLid = this.EmployeestatusList.filter(st => st.lovCode== "ACTIVE")[0].id;
      }
      else{
              this.Employee.statusLid=this.ViewEdit.Employeedata.statusLid
      }
    })
  }
  //.....................................getWithHoldingList.......................................................
  getWithHoldingList() {
    let params = new URLSearchParams();
    params.append("ListCode", "MARITALSTATUS");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.WithHoldingList = data;
    })

  }
  //......................................getLocationDropDown................................................
  getLocationDropDown() {
    this.employeeService.GetLocationDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.getLocationList = data;
      if (this.getLocationList.length > 0) {
        this.Employee.locationId = (this.Employee.locationId!=null&&this.Employee.locationId!=undefined)?this.Employee.locationId:this.getLocationList[0].Key;
      }
    },
      err => {
      })
  }
  //.....................................passvalid.......................................................
  passvalid(event) {
    let str = event.target.value;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.passerror = false;
    }
    else {
      this.passerror = true;
    }
  }
SentToEmployeePortal  (){
    this.portalBo.employeeId = this.Employee.id;
    this.portalBo.portalLink= this.configurationservice.environment.onboardingUrl+'#/onboarding/employee/'
    this.employeeService.SentToEmployee(this.portalBo).pipe(takeUntil(this.onDestroy$)).subscribe((data:any)=>{
     
      this.toasterService.success("Portal Created Successfully")
      document.getElementById('sendToEmploye').click();
        this.isEnable=false;
        //this.isDisable=true;
        if(data) {
        
          data=JSON.parse(data);
          this.Employee.loginUserId = data.loginUserId;
          this.Employee.username = data.userName;
        
          this.Employee.username != null && this.Employee.username != undefined && this.Employee.username != "" ? this.Employee.requiredEVV = true : this.Employee.requiredEVV = false;

        }       
        
      
       },
       (err: any) => {
        if (err) {
          this.toasterService.error(err, "Error"), 8000;
        }
      }
    );

      
      
       }

      
  ClearingNotes() { }
  DisablePortal() { }

  /////////////////////////////////////Event Emit from payor Reqired Id //////////////////////////////////////

  dataEmitfromChild(event: IsViewEditpayorequired) {
    // setTimeout(() => {
    this.isPayorRequiredEdit = event.isEdit;
    this.payoRequiredViewEdit = event;
    // }, 1000);


  }


  GetLanguageList() {
    if(this.ViewEdit.Employeedata.id!=null&&this.ViewEdit.Employeedata.id!=undefined&&this.ViewEdit.Employeedata.id!=''){
    let employeelanguagelist = [];

      let params = new URLSearchParams();
      params.append("EmployeeId", this.ViewEdit.Employeedata.id);
      
      this.employeeService.EmployeeLanguageList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        data.forEach(element => {
          
          employeelanguagelist?.push(element.languageLid)
        });
        this.Employee.languageLid=employeelanguagelist
  
    })
   
    }
  
  }

  
      //......................................passwordResetFunction.....................................
      passwordResetFunction() {
      
          if (
            this.Employee.loginUserId != null &&
            this.Employee.loginUserId != undefined &&
            this.Employee.loginUserId != ""
          ) {
            let params = new URLSearchParams();
            params.append("LoginUserId", this.Employee.loginUserId);
            // params.append("userRole", "CLIENT");
            let url = "api/Employee/removeEvvEmployeeCredential?";
            this.ClientService.GetFunctionwithResponseTypeText(params, url)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
              (data: any) => {
                  document.getElementById("openEvvModal").click();
                  this.toasterService.success("EVV Disabled Successfully");
                  this.sessionLogout();
                },
                (err: any) => {
                  this.toasterService.error("Kindly refresh the application!");
                }
              );
          }
        }
  
       //......................................sessionLogout.....................................
    sessionLogout() {
      let params = new URLSearchParams();
      params.append("RefreshTokenString", this.global.refreshTokenString);
      params.append("UserId", this.Employee.id.toString());
      params.append("userRole", "EMPLOYEE");
      params.append("UserName", this.Employee.username);
      params.append("AgencyCode", this.global.agencyCode);
      let url = "api/Auth/sessionLogout?";
      this.ClientService
        .GetFunctionwithResponseTypeText(params, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
           this.Employee.username = null;
          },
          (err: any) => {
            this.toasterService.error(err, "error");
          }
        );
    }


    getpermission() {
    
      if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
      let params = new URLSearchParams();
      params.append("pagecode", "employee");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.employeeService.getEmployeepermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  
        if (data != null) {
          this.fp = data;
  
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err:any) => {
          this.fp = new functionpermission();
        })
    }
  }

  EmitGoogleMapComponent(event) {
    this.Employee.zipcode = "";
    this.Employee.street = "";
    this.Employee.steet = "";
    this.Employee.county = "";
    this.Employee.apt = "";
    let street="";
    if (
      event.address_components != null &&
      event.address_components != undefined
    ) {
      event.address_components.forEach((outerArray) => {
        outerArray?.types.forEach((innerArray) => {
          if (innerArray == "administrative_area_level_2") {
            this.Employee.county = outerArray.long_name;
          }
          if (innerArray == "postal_code") {
            this.Employee.zipcode = outerArray.long_name;
          }
          if (innerArray == "administrative_area_level_1") {
            if (outerArray.long_name != null) {
              let state = this.stateList?.filter(
                (a) => a.name == outerArray.long_name
              )[0];

              this.Employee.steet = state != null ? state.abbreviation : null;
            }
          }
          if (innerArray == "subpremise") {
            let apt = outerArray.long_name.split(" ")[1];
            this.Employee.apt = (apt !=undefined && apt !=null && apt !='')? apt : outerArray.long_name;
          }
          if (innerArray == "street_number") {
            street = (outerArray.long_name !=undefined && outerArray.long_name !=null) ? outerArray.long_name +' ' :'';            
          }
          if (innerArray == "route") {
            this.Employee.street = street + outerArray.short_name;
          }
        });
      });
    }
    if (event.formatted_address != null) {
      var addressFormat = event.formatted_address.split(",");
      // this.Employee.street = addressFormat[0];
      this.Employee.city = addressFormat[1];
    }
   // this.employeevaluechange = event.isChanged;

  }
}
